import React from 'react';

function Icon({ color = '#153e35', ...props }) {
    return (
        <svg id="close" xmlns="http://www.w3.org/2000/svg" width="22.265" height="21.658" viewBox="0 0 22.265 21.658" {...props}>
            <path d="M17.988,6.272,16.68,5l-5.186,5.045L6.308,5,5,6.272l5.186,5.045L5,16.361l1.308,1.272,5.186-5.045,5.186,5.045,1.308-1.272L12.8,11.317Z" transform="translate(-0.362 -0.488)" fill={color}/>
        </svg>
    );
}

export default Icon;
